import { AxiosTransformer } from 'axios';
import { CMS_URL } from 'helpers/conf';

export interface CMSApiBase {
  id: number;
  locale: string;
  publishedAt: string;
  createdAt: string;
  updatedAt: string;
  localizations: any[];
}

type CMSImageFormatDetail = {
  name: string;
  hash: string;
  ext: string;
  mime: string;
  width: number;
  height: number;
  size: number;
  path: string | null;
  url: string;
};

interface CMSImageFormats {
  thumbnail: CMSImageFormatDetail;
  large: CMSImageFormatDetail;
  medium: CMSImageFormatDetail;
  small: CMSImageFormatDetail;
}

export interface CMSOrder {
  order: number;
}

export interface CMSImageBase {
  id: number;
  name: string;
  alternativeText: string;
  caption: string;
  width: number;
  height: number;
  formats: CMSImageFormats | null;
  hash: string;
  ext: string;
  mime: string;
  size: number;
  url: string;
  previewUrl: string | null;
  provider: string;
  providerMetadata: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface CMSResponsiveImageComponent {
  image_1394: CMSImageBase;
  image_1088: CMSImageBase;
  image_936: CMSImageBase;
  image_622: CMSImageBase;
  image_452: CMSImageBase;
}

export interface CMSArrayBase {
  id: number;
}

export interface CMSButtonParams {
  buttonType: CMSGeneralButtonType;
  buttonName: string | null;
  buttonLink: string | null;
}

const DEFAULT_LIMIT = 100;

const correctLang = (lang: string) => lang.replace('no', 'nn');

function getFormatedParams(
  path: string,
  params: Record<string, string | number | undefined> = {}
) {
  const queryParams = new URLSearchParams();

  for (const key in params) {
    const value = params[key];
    if (value !== undefined && value !== null) {
      queryParams.append(key, value.toString());
    }
  }

  return queryParams.toString();
}

export const buildCmsUrl = ({
  path,
  lang,
  limit,
  additionalParams,
}: {
  path: string;
  lang?: string;
  limit?: number;
  additionalParams?: Record<string, string | number | undefined>;
}) => {
  const formatedParams = getFormatedParams(path, {
    locale: lang ? correctLang(lang) : undefined,
    'pagination[pageSize]': limit || DEFAULT_LIMIT,
    ...additionalParams,
  });

  // TODO: use new URL() instead of string concatenation
  return `${CMS_URL}/${path}?${formatedParams}`;
};

export enum CMSGeneralButtonType {
  DEPOSIT = 'deposit',
  SHOW_MORE = 'show_more',
  EXPLORE = 'explore',
  READ_MORE = 'read_more',
  JOIN_NOW = 'join_now',
  PLAY_NOW = 'play_now',
  SOCIAL_NETWORK = 'social_network',
}

export enum CMSGroupMode {
  AND = 'AND',
  OR = 'OR',
}

export type CMSGroupParams = {
  showGuestToggle: boolean;

  groupsIncludeMode: CMSGroupMode;
  groupsInclude: string | null;
  groupsExcludeMode: CMSGroupMode;
  groupsExclude: string | null;

  durationFrom: string | null;
  durationTo: string | null;
};

export type CMSCountryParams = {
  countryCodesInclude: string | null;
  countryCodesExclude: string | null;
};

export enum EWeekday {
  Monday = 'Monday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday',
  Thursday = 'Thursday',
  Friday = 'Friday',
  Saturday = 'Saturday',
  Sunday = 'Sunday',
}

export type CMSWeekday = { weekday: EWeekday };

export type CMSScheduler = {
  scheduler?: CMSWeekday[];
};

export const LIMIT_500 = 500;

export const getResponseCMS: AxiosTransformer = (data) => data.data;
